import type { Dayjs } from 'dayjs';

export interface ComparisonDateRange {
  comparisonStartDate: Dayjs;
  comparisonEndDate: Dayjs;
}

export function getPrecedingComparisonRange(
  startDate: Dayjs,
  endDate: Dayjs,
): ComparisonDateRange {
  const lengthInDays = endDate.diff(startDate, 'day') + 1;
  const comparisonEndDate = startDate.subtract(1, 'day');
  const comparisonStartDate = comparisonEndDate.subtract(
    lengthInDays - 1,
    'day',
  );

  return { comparisonStartDate, comparisonEndDate };
}
